import React from 'react';
import { Button } from '@material-ui/core';
import { Room } from '@material-ui/icons';

import useStyles from './useStyles';

const GeoLocationsButton = (props) => {
  const classes = useStyles();

  return (
    <Button {...props} className={classes.root} variant={'text'} startIcon={<Room />}>
      GPS Coordinates
    </Button>
  );
};

export default GeoLocationsButton;
